import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import 'react-phone-number-input/style.css'
import Alert from '../../components/Alert/Alert';
import { selectUserRequestsData } from '../../redux/apiSlices/requestSlice';
import AddAttachmentModal from './AddAttachmentModal';
import { useCreateReportMutation } from '../../redux/apiSlices/organizationSlice';


function CreateReport() {

  const data = useSelector(selectUserRequestsData)

  const navigate = useNavigate();


  const [createReport, {isLoading}  ] = useCreateReportMutation();

  const [title, setTitle] = useState('');
  const [selectedRequest, setSelectedRequest] = useState(data?.requests[0].id);
  const [content, setContent] = useState('');
  const [files, setFiles] = useState([]);

  const [showAttachModal, setShowAttachModal] = useState(false)


  const handleShowAttachModal = () => {

    setShowAttachModal(true)
  }


  const handleTitle = (event) => {
    setTitle(event.target.value);
  }

  

  

 

  

  const handleContent = (event) => {
    setContent(event.target.value);
  }

  const handleAddAttchment = (attch) => {
    console.log(attch)
    setFiles(prev => [...prev, attch ]);
    

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(files)
    
    
    let formData = new FormData();
    formData.append('title', title);
    formData.append('content', content);
    formData.append("request_id", selectedRequest)
    for (let i = 0; i < files?.length; i++) {
      let title = files[i].title ? files[i].title : files[i].file.name
      formData.append("attachments", files[i].file, title)
      console.log('index', i)
    }
    try {
      await createReport(formData).unwrap()
      navigate('/successful-page/generl')

    } catch (err) {
        console.error('Failed to save the changes', err)
      }
   

  };
  return (
    <>
    <AddAttachmentModal
      showModal={showAttachModal}
      handleCloseModal={()=> setShowAttachModal(false)}
      handleAddAttchment={handleAddAttchment}
      />
    
    <div class="col-xl-9">
      <div class="card bg-transparent border rounded-3">
          {/* <!-- Card header --> */}
          <div class="card-header bg-transparent border-bottom">
            <h3 class="card-header-title mb-0">إنشاء تقرير</h3>
          </div>
          {/* <!-- Card body START --> */}

          {data?.requests?.length < 1 ?
           <div class='my-3'> <Alert type='error' text='لا توجد طلبات معتمدة للمؤسسة حتى يتسنى لك إنشاء تقرير لها' /> </div>
            : 
           data?.verification_status === "unverified" ? 
           <div class='my-3'> <Alert type='error' text='يرجى تقديم طلب توثيق الحساب حتى يتسنى لك تقديم التقارير' /> </div>
           : 
           data?.verification_status === "pending" ? 
           <div class='my-3'> <Alert type='error' text='سيتسنى لك تقديم التقارير بعد أن يتم توثيق حسابك' /> </div>
           : 
          
          <div class="card-body">
          {/* <!-- Form --> */}
            <form class="row g-4">

                {/* <!-- Title --> */}
                <div class="col-lg-6">
                <label class="form-label">عنوان التقرير</label>
                    <input 
                    type="text" 
                    class="form-control" 
                    value={title} 
                    onChange={handleTitle}
                    placeholder="عنوان التقرير"
                    />
                    </div>

                  {/* <!-- request --> */}
                  <div class="col-md-6">
                        <label class="form-label">العريضة</label>
                        <select value={selectedRequest} onChange={(e)=> setSelectedRequest(e.target.value)} name='level' class="form-select" aria-label=".form-select-sm">
                            <option value="" disabled>اختر العريضة</option>
                            {data?.requests.map(rq=>(
                              <option key={rq.id} value={rq.id}>{rq.title}</option>
                            ))}
                        </select>
                  </div>

                

               {/* <!-- Content --> */}
               <div class="col-12">
                <label class="form-label">محتوى التقرير</label>
                <textarea
                    class="form-control" 
                    rows="10"
                    placeholder="محتوى التقرير"
                    value={content}
                    onChange={handleContent}
                    />
                </div>

                 {/* <!-- Add Attachments --> */}
            <div className='my-4'>
                <div class="d-sm-flex justify-content-sm-between align-items-center">
                  <h5 class="mb-2 mb-sm-0">المرفقات</h5>
                  <div>
                  {isLoading ? 
                    <button class="btn btn-success" type="button" disabled>
                      <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      يتم التحميل...
                    </button> :
                      <button type='button' onClick={handleShowAttachModal} class="btn btn-sm btn-success-soft mb-0"><i class="bi bi-plus-circle me-2"></i>إضافة مرفق جديد</button>}
                  </div>
                </div>
                <div className='mt-3'>
                 {files.map((at,i)=>(
                  <div key={i} className='d-flex align-items-center mb-2'>
                  <i class="bi bi-book fa-fw me-2"></i>
                  <p className='mb-0'>{at.title}</p>
                </div>
                 ))} 
                 
                </div>
              </div>
          


                


                {/* <!-- Save button --> */}
                
                <div class="d-flex justify-content-end mt-4">
                    {isLoading ?
                    <button class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        يتم التحميل...
                    </button> 
                    :
                    <button onClick={handleSubmit} class="btn btn-primary mb-0">تأكيد</button>
                    }
                </div>



                

                <div class='row'>
                
                
                </div>


            </form>
          </div>
          }
          {/* <!-- Card body END --> */}
        </div>
	  </div>
    </>
  )
}

export default CreateReport